import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App as AntdApp, Spin } from 'antd';
import AppLayout from './layouts/AppLayout';
import { useAppStore } from './stores/useAppStore';

const ChatPage = lazy(() => import('./pages/ChatPage'));
const FileLibrary = lazy(() => import('./pages/FileLibrary'));
const Settings = lazy(() => import('./pages/Settings'));
const Setup = lazy(() => import('./pages/Setup'));
const Login = lazy(() => import('./pages/Login'));
const FeedbackPage = lazy(() => import('./pages/FeedbackPage'));
// const Credits = lazy(() => import('./pages/Credits')); // 内测暂不开放

const Loading = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
    <Spin size="large" />
  </div>
);

function App() {
  const authToken = useAppStore((s) => s.authToken);
  const loadConfigFromServer = useAppStore((s) => s.loadConfigFromServer);

  useEffect(() => {
    if (authToken) {
      loadConfigFromServer();
    }
  }, [authToken, loadConfigFromServer]);

  return (
      <AntdApp>
        <BrowserRouter>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/login" element={<Login />} />
              {!authToken ? (
                <Route path="*" element={<Navigate to="/login" replace />} />
              ) : (
              <Route element={<AppLayout />}>
                  <Route path="/" element={<ChatPage />} />
                  <Route path="/files" element={<FileLibrary />} />
                  {/* <Route path="/credits" element={<Credits />} /> */} // 内测暂不开放
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/settings/:tab" element={<Settings />} />
                  <Route path="/setup" element={<Setup />} />
                  <Route path="/feedback" element={<FeedbackPage />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              )}
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AntdApp>
  );
}

export default App;